/* eslint-disable react-hooks/exhaustive-deps */
import { isEqual } from "lodash";
import React, { useEffect, useState } from "react";
import { modifyAccountingTitle } from "../../../apis/finances/accounting-title";
import Form from "../../../components/Form";
import Modal, { ModalHeader } from "../../../components/Modal";
import useForm from "../../../hooks/useForm";
import systemAlert from "../../../utils/systemAlert";

const defaultForm = {
  name: "",
}

const CategoryModal = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props
  const [fields] = useState([
    [
      {
        title: "카테고리명",
        key: "name",
        type: "input",
        required: true,
      },
    ],
    [
      { title: "계정체계", key: "class", type: 'text' },
      { title: "코드", key: "code", type: 'text' },
    ],
    [
      { title: "성격", key: "kind", type: 'text' },
      { title: "관계코드", key: "refCode", type: 'text' },
    ]
  ]);

  useEffect(() => {
    setValidateFields(fields)
    if (selectedItem) {
      setForm(selectedItem)
      setOriginForm(selectedItem)
    }
  }, [open, selectedItem]);

  const _submit = (form) => {
    const body = {
      name: form.name
    }

    systemAlert(`"${form.name}" 카테고리를 수정하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            modifyAccountingTitle(form.code, body)
              .then(() => {
                cancel();
                if (submit) {
                  submit()
                }
              })
          }
        }
      ]
    })
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    originForm,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setSelectedItem(null)
  };

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>{selectedItem && <>"{`${selectedItem.name}(${selectedItem.code})`}"</>} 카테고리명 수정</ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={'수정'}
          submit={handleSubmit}
          cancel={cancel}
          isDisabledSubmit={isEqual(form, originForm)}
        />
      </div>
    </Modal>
  );
};

export default CategoryModal;
